// eslint-disable-next-line no-shadow
export enum StudioSidebarViews {
	LIGHTNING = 'lightning',
	FLUX = 'flux',
	MAGICMODE = 'magicmode',
	PROMODE = 'promode',
	MODELS = 'models',
	SETTINGS = 'settings',
	LORA = 'lora',
	CONTROLNET = 'controlnet',
	FACELOCK = 'facelock',
	CHANGE_ANYTHING = 'changeanything',
	TRUE_TOUCH = 'truetouch',
	NONE = 'none',
	CHARACTER_LAB = 'character-lab',
	NARRATOR = 'narrator',
	UPSCALE_8K = 'upscale8k',
	PROMPT_GENERATOR = 'promptgenerator',
	SEED = 'seed',
	VIDEO_ANYONE = 'video-anyone',
	FACE_REPLACE = 'face-replace',
	FACE_SWAP = 'face-swap',
	MUSIC_VIDEO = 'musicvideo',
	CHANGE_CLOTHING = 'change-clothing',
	PRODUCT_PHOTO = 'product-photo',
}
